// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rsBQq","largestCol":"styles_largestCol__2nii5","smallestCol":"styles_smallestCol__2PIqN"};